import { axiosInstance } from "./apiConfig";
const HOST_API = process.env.REACT_APP_API_URL;


export const GetPropertyList = async () => {
    try {
        const res = await axiosInstance.get(`/Re_Properties/GetRe_PropertiesList`);
        //  console.log(res, "proppppp")
        return res?.data;
    } catch (error) {
        console.log(error, "data not get");

    }

}


export const GetBlogList = async () => {
    try {
        const res = await axiosInstance.get(`/BlogPost/AllBlogList`);
        console.log(res, "blogssssss");

        return res?.data;
    } catch (error) {
        console.log(error, "data not get");

    }

}

export const GetBlogDetailsBySlug = async (slug) => {
    try {
        const res = await axiosInstance.get(`/BlogPost/AllBlogList?slug=${slug}`);
        console.log(res, "blogssssss");

        return res?.data;
    } catch (error) {
        console.log(error, "data not get");

    }

}


export const GetBuildingTypeList = async () => {
    try {
        const res = await axiosInstance.get(`/BuildingType/GetBuildingTypeList`);
        //  console.log(res, "proppppp")
        return res?.data;
    } catch (error) {
        console.log(error, "data not get");

    }
}

export const GetSearchBy_CityBy_Location = async (params) => {
    try {
        const res = await axiosInstance.get(`/Localities/SearchByCity_ByLocality`, {
            params: params
        });
        //   console.log(res, "cityyyyyy")
        return res?.data;
    } catch (error) {
        console.log(error, "data not get");

    }
}

export const searchProperty = async (data) => {
    try {
        const res = await axiosInstance.post(`/Re_Properties/GetRe_Properties_SearchList`, data, {
            headers: {
                //   Authorization: "Bearer " + token,
            },
        });
        return res.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const GetCityList = async () => {
    try {
        const res = await axiosInstance.get(`/Cities/GetCitiesList`);
        //  console.log(res, "proppppp")
        return res?.data;
    } catch (error) {
        console.log(error, "data not get");

    }

}

export const GetLocalitiesList = async () => {
    try {
        const res = await axiosInstance.get(`/Localities/GetLocalitiesList`);
        //  console.log(res, "proppppp")
        return res?.data;
    } catch (error) {
        console.log(error, "data not get");

    }

}


export const GetPropertiesDetails = async (data) => {
    try {
        const res = await axiosInstance.post(`/Re_Properties/GetRe_PropertiesDetails`, data, {
            headers: {
                //   Authorization: "Bearer " + token,
            },
        });
        return res.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
};

export const SendMail = async (data) => {
  try {
    const res = await axiosInstance.post(`https://trinetskyapi.pixonix.tech/contact`, data);
    return res?.data;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

 
export const NewSaveLeadForSales = async (data) =>{
    try {
        const res = await axiosInstance.post(`${HOST_API}/PipelineLead/NewSaveLeadForSales` , data);
        return res?.data;
    }catch(error){
        console.log(error);
        
    }

}

